// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lbndatoxvjgaqnqoflvf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxibmRhdG94dmpnYXFucW9mbHZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5NDA0MDksImV4cCI6MjA5MTUxNjQwOX0.HRIRWHijA1dEHjpSBPRjRgJ4EmrVFPeeDQQqDCX6ZOA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});